import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import moment from "moment-timezone";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./redux/store";
import { ClearBrowserCacheBoundary } from "react-clear-browser-cache";
import { Provider } from "react-redux";

import jwtDecode from "jwt-decode";
import {
  getAuthorize,
  getMenu,
  getPermission,
} from "./redux/actions/login.action";

moment.tz("Asia/Bangkok").format();

const token = localStorage.getItem("token");

// check login
if (token) {
  const dcode = jwtDecode(token);
  store.dispatch({ type: "LOGIN_SUCCESS", payload: dcode.sub });
  store.dispatch(getPermission());
  store.dispatch(getMenu());
  store.dispatch(getAuthorize(dcode.sub));
}

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ClearBrowserCacheBoundary
          auto
          fallback="Loading"
          duration={60000}
          filename="prs/meta.json"
        >
          <App />
        </ClearBrowserCacheBoundary>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
